export default "__VITE_ASSET__D9c7ddEA__"